'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MealPlanner$SearchParams(mainCategory, cuisine, course) {
  this.wL = null;
  this.wK = null;
  this.wJ = null;
  this.wL = mainCategory;
  this.wK = cuisine;
  this.wJ = course;
}
export { $c_Lmealorama_components_MealPlanner$SearchParams as $c_Lmealorama_components_MealPlanner$SearchParams };
$p = $c_Lmealorama_components_MealPlanner$SearchParams.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MealPlanner$SearchParams;
/** @constructor */
function $h_Lmealorama_components_MealPlanner$SearchParams() {
}
export { $h_Lmealorama_components_MealPlanner$SearchParams as $h_Lmealorama_components_MealPlanner$SearchParams };
$h_Lmealorama_components_MealPlanner$SearchParams.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-421624380), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_MealPlanner$SearchParams)) {
    var x = this.wL;
    var x$2 = x$0.wL;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.wK;
      var x$4 = x$0.wK;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.wJ;
      var x$6 = x$0.wJ;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 3;
});
$p.r = (function() {
  return "SearchParams";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.wL;
      break;
    }
    case 1: {
      return this.wK;
      break;
    }
    case 2: {
      return this.wJ;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_MealPlanner$SearchParams(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ke)));
}
export { $isArrayOf_Lmealorama_components_MealPlanner$SearchParams as $isArrayOf_Lmealorama_components_MealPlanner$SearchParams };
var $d_Lmealorama_components_MealPlanner$SearchParams = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MealPlanner$SearchParams, "mealorama.components.MealPlanner$SearchParams", ({
  ke: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_MealPlanner$SearchParams as $d_Lmealorama_components_MealPlanner$SearchParams };
//# sourceMappingURL=mealorama.components.-Meal-Planner$-Search-Params.js.map
